import React from 'react';
import {useFormContext, useWatch} from 'react-hook-form';
import {TaskRepresentationProps} from './VoidTask';
import TaskTypeField from '../TaskTypeField';
import TargetField from './change-status/TargetField';
import StatusField from './change-status/StatusField';
import WillChangeAtField from './change-status/WillChangeAtField';
import CommentField from './change-status/CommentField';
import Comment from '../../../../../src/components/CommentsList/Comment';
import OrderProductField from './OrderProductField';

export default function ChangeStatusTask({formId, task, order, isDisabled}: TaskRepresentationProps<'change-status'>) {
    const {control} = useFormContext();
    const target = useWatch({control, name: 'payload.target'});

    const colClassName = 'col-12 col-md';

    return <div className="row">
        <div className={colClassName}>
            <TaskTypeField formId={formId} task={task} isDisabled={isDisabled}/>
        </div>

        <div className={colClassName}>
            <TargetField formId={formId} task={task} isDisabled={isDisabled}/>
        </div>

        {target === 'order-product' ? <div className={colClassName}>
            <OrderProductField formId={formId} products={order.products} isDisabled={isDisabled}/>
        </div> : null}

        <div className={colClassName}>
            <StatusField formId={formId} isDisabled={isDisabled}/>
        </div>

        <div className={colClassName}>
            <WillChangeAtField formId={formId} isDisabled={isDisabled}/>
        </div>

        <div className="col-12">
            {task.id ? null : <CommentField formId={formId} isDisabled={isDisabled}/>}

            {task.comment ? (
                    <div className="mt-3">
                        <Comment model={task.comment} size="sm"/>
                    </div>
            ) : null}
        </div>
    </div>;
}
